export default __webpack_public_path__ + "static/media/rally.ace0098e.png";